import { useMemo } from "react";
import { geoLocationFilter } from "@/react/components/SettingsApp/ManageMembers/TabContent/Filters/filterConfiguration";
import { useCrmTrueLocationFieldAndSearchEnabled } from "@/react/components/shared/MemberFilters/useCrmLocationEnabled";
import { useCrmFilterFields } from "@/react/hooks/useCrmFilters";
import { MemberFilters } from "@circle-react-shared/MemberFilters";
import { AllFiltersList } from "@circle-react-shared/MemberFilters/DynamicFilters";
import type { RenderFilter } from "@circle-react-shared/MemberFilters/types";
import { membersSpaceFilters } from "./membersSpaceFilters";

const platformMemberFilters: RenderFilter[] = membersSpaceFilters;

export const MembersFilters = () => {
  // Mobile version of filters are not ready, so hide for time being
  // Check this to understand how do default filters work:
  // https://circleso.slack.com/archives/C042U01RB5F/p1686928787694659

  const isCrmTrueLocationFieldAndSearchEnabled =
    useCrmTrueLocationFieldAndSearchEnabled();

  const defaultFilterNames = useMemo(
    () => [
      ...(isCrmTrueLocationFieldAndSearchEnabled ? ["near_me"] : []),
      "name",
      "headline",
      "role",
      "online_status",
      ...(isCrmTrueLocationFieldAndSearchEnabled
        ? [geoLocationFilter.name]
        : []),
    ],
    [isCrmTrueLocationFieldAndSearchEnabled],
  );

  const crmFilters = useCrmFilterFields();

  return (
    <div className="shadow-xs hidden md:flex">
      <MemberFilters
        platformFilters={[...platformMemberFilters, ...crmFilters]}
        defaultFilterNames={defaultFilterNames}
        persistentFilterNames={
          isCrmTrueLocationFieldAndSearchEnabled ? ["near_me"] : []
        }
      >
        <AllFiltersList />
      </MemberFilters>
    </div>
  );
};
